export const colorPrimary = {
  nd500: '#17344a',
  nd400: '#254157',
  nd300: '#335267',
  nd200: '#527187',
  nd100: '#7992a5',

  nl500: '#bccad4',
  nl400: '#d5dfe6',
  nl300: '#ebf3f5',
  nl200: '#f9fbfc',
  nl100: '#f2f4f5',
  nl0: '#ffffff',

  lime400: '#548a0b',
  lime300: '#74b816',
  lime200: '#82c91e',
  lime100: '#f4fce3',

  purple500: '#6741d9',
  purple400: '#7048e8',
  purple300: '#7950f2',
  purple200: '#9775fa',
  purple100: '#f3f0ff',

  blue500: '#1864ab',
  blue400: '#1971c2',
  blue300: '#339af0',
  blue200: '#d0ebff',
  blue100: '#d9efff',

  cyan200: '#3bc9db',
  cyan100: '#66d9e8',

  red500: '#a60a0a',
  red400: '#c92a2a',
  red300: '#e03131',
  red200: '#f03e3e',
  red100: '#ffe3e3',

  yellow500: '#623300',
  yellow400: '#a95700',
  yellow300: '#ffd43b',
  yellow200: '#ffec99',
  yellow100: '#fff3bf',

  teal400: '#007350',
  teal300: '#099268',
  teal200: '#20c997',
  teal100: '#c3fae8',

  black: '#000000',
} as const;

export type ColorPrimaryKey = keyof typeof colorPrimary;
